<div class="p-fluid w-[450px]">
  <form [formGroup]="form" (ngSubmit)="onSave()" class="flex flex-col gap-4">
    <app-form-field
      id="originalFilename"
      label="common.originalFilename"
      fieldName="originalFilename"
    ></app-form-field>

    <app-form-field id="fileName" label="common.fileName" fieldName="fileName"></app-form-field>

    <app-form-field id="version" label="common.version" fieldName="version"></app-form-field>

    <app-form-field-select-button
      id="statusUuid"
      label="common.status"
      fieldName="statusUuid"
      [options]="uploadDocumentStatusOptions()"
      [isMandatory]="true"
    ></app-form-field-select-button>

    <div class="flex justify-end gap-2">
      <p-button
        [label]="'common.cancel' | transloco"
        severity="secondary"
        (onClick)="onHideDialog()"
      ></p-button>
      @if (form.valid) {
        <p-button [label]="'common.upload' | transloco" type="submit"></p-button>
      }
    </div>
  </form>
</div>
